// 自社情報（請求書用）設定ローダー。settings/company ドキュメント1件。
// 流儀は demoData.js（settings/display）・laborRates.js（settings/labor）と同じ。
// 既定・正規化は companyInfo.core.js に集約（純ロジック＝テスト対象）。
import { COLLECTIONS, getOne, upsert } from './collections.js'
import { supabaseReady } from '../supabase.js'
import { DEFAULT_COMPANY, COMPANY_FIELDS, resolveCompany } from './companyInfo.core.js'

let _company = { ...DEFAULT_COMPANY }
let _loaded = false

export function getCompany() { return { ..._company } }
export function companyLoaded() { return _loaded }

// 未接続（デモ）でも既定値で紙が成立する＝請求書の見た目確認がオフラインでもできる
export async function loadCompany() {
  if (!supabaseReady) return { ...DEFAULT_COMPANY }
  try { return resolveCompany(await getOne(COLLECTIONS.settings, 'company')) }
  catch { return { ...DEFAULT_COMPANY } }
}

export async function refreshCompany(force) {
  if (_loaded && !force) return getCompany()
  _company = await loadCompany()
  _loaded = true
  return getCompany()
}

export async function saveCompany(patch) {
  const next = resolveCompany({ ..._company, ...(patch || {}) })
  if (supabaseReady) await upsert(COLLECTIONS.settings, 'company', { ...next, updatedAt: new Date().toISOString() })
  _company = next
  _loaded = true
  return getCompany()
}

export { DEFAULT_COMPANY, COMPANY_FIELDS, resolveCompany }
